module.exports = __webpack_public_path__ + "img/25.4aa4fe1c.jpg";